export enum MessageType {
	ERROR = <any>{ class: "error" },
	WARNING = <any>{ class: "warning" },
	SUCCESS = <any>{ class: "success" }
}
